module.exports = __webpack_public_path__ + "img/practiceLogoWeb_white-05.f89838d7.png";